import { render, staticRenderFns } from "./fileTable.vue?vue&type=template&id=be79e71a&scoped=true"
import script from "./fileTable.vue?vue&type=script&lang=js"
export * from "./fileTable.vue?vue&type=script&lang=js"
import style0 from "./fileTable.vue?vue&type=style&index=0&id=be79e71a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be79e71a",
  null
  
)

export default component.exports